<template>
    <button
        v-tippy="t('editorToggleItalic')"
        :class="[
            buttonState(
                editor.can().toggleItalic() && editorSelection.text.length > 0,
                editor.isActive('italic'),
            ),
            'flex-none rounded p-1 text-sm',
        ]"
        :disabled="!editor.can().toggleItalic() || editorSelection.text.length === 0"
        @click="editor.chain().focus().toggleItalic().run()"
    >
        <MdiFormatItalic class="h-6 w-6" />
    </button>
</template>
<script setup>
    import { buttonState } from '../../composables/useWYSIWYGEditorUtils';
    import { MdiFormatItalic } from 'materialdesignicons-vue3/icons/';

    defineExpose({
        name: 'ItalicTextButton',
    });

    const props = defineProps({
        editor: {
            type: Object,
            required: true,
        },
        editorSelection: {
            type: Object,
            required: true,
        },
    });

    const editor = props.editor;
    const editorSelection = props.editorSelection;
</script>
